import { isNull } from 'lodash'
import store from '../store/index'
import * as types from '../modules/auth/store/mutations_types'

const isLogged = () => store.getters.isLogged

const isMemberEmpty = () => typeof store.getters.getMember.id === 'undefined'

const isAdmin = () => store.getters.isMemberAdmin

const isInactiveAccount = () => store.getters.isInactiveAccount

const hasTokenStored = () => !isNull(window.localStorage.getItem('pml_token'))

const getTokenStored = () => window.localStorage.getItem('pml_token')

const requiresAuthIsNull = route => route.meta.requiresAuth === null

const routeRequiresAuth = route => route.matched.some(record => record.meta.requiresAuth)

const isAdminRoute = route => route.matched.some(record => record.meta.isAdminRoute)

const checkAccess = (to, next) => {
    if (isInactiveAccount() && to.name !== 'subscription.index' && to.name !== 'auth.login' && to.name !== 'trial.index')
        next({name: 'subscription.index'})
    else if (isAdminRoute(to) && !isAdmin())
        next({name: 'error.403'})
    else if (requiresAuthIsNull(to))
        next()
    else if (routeRequiresAuth(to) && !isLogged())
        next({path: 'login', query: {redirect: to.fullPath}})
    else
        next()
}

export default (to, from, next) => {
    if (hasTokenStored() && isMemberEmpty())
        store.dispatch('initProfile')
            .then(() => store.commit(types.SET_TOKEN, getTokenStored()))
            .then(() => checkAccess(to, next))
    else
        checkAccess(to, next)
}



// WEBPACK FOOTER //
// ./src/router/beforeEach.js